import React, { ReactElement } from 'react'
import styled from 'styled-components'
import {
  CgChevronLeft as ArrowLeft,
  CgChevronRight as ArrowRight,
} from 'react-icons/cg'
import moment, { Moment } from 'moment'
import colors from '../lib/colors'
import theme from '../lib/theme'
import { getOverviewDateRange } from './reportingHelper'
import FieldStyles from '../components/FieldStyles'

const RangeContainer = styled.div`
  display: flex;
  border-radius: 4px;
  border: 1px solid ${colors.darkGray};
  padding: 0 5px;
  height: ${theme.fieldHeight};
  box-sizing: border-box;
  width: fit-content;

  > div,
  > button {
    margin-left: 20px;
    &:first-child {
      margin-left: 0;
    }
  }
`
const RangeButton = styled.button`
  border: none;
  padding: 0;
  background: inherit;
  font-size: inherit;
  font-family: inherit;

  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
  color: ${colors.black};
  transition: color 0.2s;
  :hover {
    color: ${colors.lightBlue};
  }
  svg {
    width: 16px;
    height: auto;
    margin: 0 2px;
  }
  :disabled {
    color: ${colors.darkGray};
    cursor: default;
  }
`
const CurrentRange = styled.div`
  display: flex;
  align-items: center;
  color: ${colors.lightBlue};
  font-weight: bold;
  text-align: center;
  white-space: nowrap;
`
interface IPeriodSelectorProps {
  now?: Moment
  fromMonth: number
  setFromMonth: (month: number) => void
  fromYear: number
  setFromYear: (year: number) => void
}
export default function PeriodSelector(
  props: IPeriodSelectorProps,
): ReactElement {
  const {
    now = moment(),
    fromMonth,
    setFromMonth,
    fromYear,
    setFromYear,
  } = props

  const handlePreviousMonth = (): void => {
    if (fromMonth > 1) {
      setFromMonth(fromMonth - 1)
    } else {
      setFromMonth(12)
      setFromYear(fromYear - 1)
    }
  }
  const handleNextMonth = (): void => {
    if (fromMonth < 12) {
      setFromMonth(fromMonth + 1)
    } else {
      setFromMonth(1)
      setFromYear(fromYear + 1)
    }
  }

  const handlePreviousYear = (): void => setFromYear(fromYear - 1)
  const handleNextYear = (): void => setFromYear(fromYear + 1)

  const fromDate = moment(`${fromMonth}/${fromYear}`, 'M/YYYY')
  const nowMonth = now.clone().startOf('month')
  const disableNextMonth = fromDate.clone().add(11, 'months') >= nowMonth
  const disableNextYear = fromDate.clone().add(22, 'months') >= nowMonth

  return (
    <FieldStyles label="Select period">
      <RangeContainer>
        <RangeButton onClick={handlePreviousYear}>
          <ArrowLeft />
          Year
        </RangeButton>
        <RangeButton onClick={handlePreviousMonth}>
          <ArrowLeft />
          Month
        </RangeButton>
        <CurrentRange>{getOverviewDateRange(fromMonth, fromYear)}</CurrentRange>
        <RangeButton
          onClick={handleNextMonth}
          style={{ textAlign: 'right' }}
          disabled={disableNextMonth}
        >
          Month
          <ArrowRight />
        </RangeButton>
        <RangeButton
          onClick={handleNextYear}
          style={{ textAlign: 'right' }}
          disabled={disableNextYear}
        >
          Year
          <ArrowRight />
        </RangeButton>
      </RangeContainer>
    </FieldStyles>
  )
}
